import React from "react";
import { Helmet } from "react-helmet-async";
import Header from "../Sections/Header";
import Footer from "../Sections/Footer";
import Price from "../Sections/Price";
import NicheHero from "../Components/NicheShared/NicheHero";
import NicheFeatures from "../Components/NicheShared/NicheFeatures";
import NicheSteps from "../Components/NicheShared/NicheSteps";
import NicheCTA from "../Components/NicheShared/NicheCTA";
import NicheFollowUp from "../Components/NicheShared/NicheFollowUp";
import RevealOnScroll from "../Components/RevealOnScroll";
import { NavLink } from "../types/nav";
import { NicheConfig } from "./data/niches";

interface NicheTemplateProps {
  config: NicheConfig;
}

const NicheTemplate: React.FC<NicheTemplateProps> = ({ config }) => {
  const links: NavLink[] = [
    { label: "Início", to: "/" },
    { label: "Funcionalidades", to: `${config.route}#features` },
    { label: "Como funciona", to: `${config.route}#steps` },
    { label: "Planos", to: `${config.route}#price` },
  ];

  const canonicalUrl = `https://alfredchat.com.br${config.route}`;

  return (
    <>
      <Helmet>
        <title>{config.seo.title}</title>
        <meta name="description" content={config.seo.description} />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph */}
        <meta property="og:title" content={config.seo.title} />
        <meta property="og:description" content={config.seo.description} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={config.seo.title} />
        <meta name="twitter:description" content={config.seo.description} />

        {/* JSON-LD Service */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": config.name,
            "serviceType": config.name,
            "provider": {
              "@type": "Organization",
              "name": "Alfred",
              "url": "https://alfredchat.com.br",
              "email": "contato@alfredchat.com.br",
            },
          })}
        </script>
      </Helmet>
      <Header links={links} />
      <NicheHero
        id="hero"
        headline={config.hero.headline}
        subheadline={config.hero.subheadline}
      />
      <RevealOnScroll>
        <NicheFeatures id="features" features={config.features} />
      </RevealOnScroll>
      <RevealOnScroll>
        <NicheSteps id="steps" steps={config.steps} />
      </RevealOnScroll>
      <RevealOnScroll>
        <NicheFollowUp
          title={config.followUp.title}
          subtitle={config.followUp.subtitle}
          items={config.followUp.items}
        />
      </RevealOnScroll>
      <RevealOnScroll>
        <NicheCTA phrase={config.ctaPhrase} />
      </RevealOnScroll>
      <div id="price">
        <Price />
      </div>
      <Footer />
    </>
  );
};

export default NicheTemplate;
